var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "nav nav--steps" },
    _vm._l(_vm.totalSteps, function (step) {
      return _c(
        "li",
        { class: { active: step === _vm.currentStep } },
        [
          _c("router-link", { attrs: { to: `${_vm.routeBase}/${step}` } }, [
            _vm._v(_vm._s(step)),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }